module.exports = __webpack_public_path__ + "static/media/Rapport2.f54ef20c.png";